(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      if ('ResizeObserver' in window && this.header) {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      } else {
        window.addEventListener('resize', this.setHeaderHeight.bind(this), { passive: true });
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header) {
        if (scrollTop > 40) {
          this.header.classList.add('is-sticky');
        } else {
          this.header.classList.remove('is-sticky');
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerBounds && scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
        this.header && this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (this.headerBounds && scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
        this.header && this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (this.headerBounds && scrollTop <= (this.headerBounds.top || 0)) {
        this.header && this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('searchModal');     
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Safe navigation click handler for desktop menu with touch-device first-tap-to-open support
  document.addEventListener('DOMContentLoaded', function() {
    var wdtHeaderMenu = document.querySelector('.dt-desktop-menu');
    if (!wdtHeaderMenu) return;

    var dropdownToggles = wdtHeaderMenu.querySelectorAll('.nav-item > a.dropdown-toggle');
    dropdownToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        var parentItem = this.closest('.nav-item');
        var isTouch = window.matchMedia('(pointer: coarse)').matches;

        // On touch screens: first tap opens the dropdown submenu; second tap navigates to parent URL
        if (isTouch && parentItem && !parentItem.classList.contains('touch-opened')) {
          e.preventDefault();
          e.stopPropagation();
          wdtHeaderMenu.querySelectorAll('.nav-item.touch-opened').forEach(function(item) {
            if (item !== parentItem) item.classList.remove('touch-opened');
          });
          parentItem.classList.add('touch-opened');
          return;
        }

        if (href && href !== '#' && href !== 'javascript:void(0)') {
          window.location.href = this.href;
        }
      });
    });

    // Tap outside closes touch-opened dropdowns
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.dt-desktop-menu')) {
        document.querySelectorAll('.dt-desktop-menu .nav-item.touch-opened').forEach(function(item) {
          item.classList.remove('touch-opened');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
